export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13592.c97dd6a6.jpg";